import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllTagsTable from './Table';
import AdminPageHead from '../../Common/PageHead';
import NewTagModal from '../../Modals/Tag/NewTagModal';
import style from './styles/style.module.css';

class AllTagsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            tags: [],
            tagQueryObject: {
                sort: 'tagtext,tagid',
            },
            newModal: false,
        };
    }
    componentDidMount() {
        this.loadTags();
    }
    onColumnSort = ( value ) => {
        if( this.state.tagQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.tags = [];
            prevState.tagQueryObject.page = 1;
            prevState.tagQueryObject.sort = value || undefined;
            return prevState;
        } );
        this.loadTags();
    }
    onSearch = ( value ) => {
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.tags = [];
            prevState.tagQueryObject.page = 1;
            prevState.tagQueryObject.search = value || undefined;
            return prevState;
        } );
        this.loadTags();
    }
    loadTags = () => {
        return this.props.getTags( this.state.tagQueryObject )
        .then( ( tags ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false,
                prevState.tags = prevState.tags.concat( tags ),
                prevState.tagQueryObject.page++;
                return prevState;
            } );
            return tags;
        } );
    }
    tagUpdated = ( index, tag ) => {
        this.setState( ( altState ) => {
            if( tag !== null ) {
                altState.tags[ index ] = tag;
                altState.tags = altState.tags.slice( 0 );
            } else {
                altState.tags = altState.tags.slice( 0, index ).concat( altState.tags.slice( index +1 ) );
            }
            return altState;
        } );
    }
    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newTag ) => {
        this.setState( ( altState ) => {
            altState.tags.unshift( newTag );
            altState.tags = altState.tags.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, tags } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Tags'
                onSearch={ this.onSearch }
                tabs={ [
                    { label: 'View All', to: '/admin/tags' },
                ] }
                buttons={ [
                    { label: '+ Add New Tag', onClick: this.openNewModal },
                ] } />
                <div className={ style.body }>
                    <section className={ style.allList }>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllTagsTable
                            tags={ tags }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.state.tagQueryObject.sort }
                            onTagUpdated={ this.tagUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewTagModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getTags: ( queryObject ) => {
            return dAPI.get( '/tags', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllTagsView );
